import AOS from 'aos';
import 'aos/dist/aos.css';
export default (function (_ref) {
  var Vue = _ref.Vue;
  var aosPlugin = {
    install: function install() {
      AOS.init({// add your settings here
      });
    }
  };
  setTimeout(function () {
    Vue.use(aosPlugin);
  }, 1000);
});